// components/MultiTabBlocker/MultiTabBlocker.tsx

import { Box, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

interface MultiTabBlockerProps {
  open: boolean;
  onActivate: () => void;
}

export const MultiTabBlocker = ({ open }: MultiTabBlockerProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (!open) return null;

  document.body.style.overflow = "hidden";

  return (
    <Box
      sx={ {
        alignItems: "center",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        left: 0,
        position: "fixed",
        top: 0,
        width: "100vw",
        zIndex: 9999
      } }
    >
      <Paper
        elevation={ 3 }
        sx={ {
          backgroundColor: theme.palette.background?.paper,
          maxWidth: 500,
          padding: 4,
          textAlign: "center"
        } }
      >
        <Typography variant="h4" gutterBottom color="error">
          { t("attention") }
        </Typography>
        
        <Typography variant="body1" paragraph>
          { t("multitab_error_description") }
        </Typography>

        { /* <Button 
          variant="contained" 
          color="primary" 
          onClick={ onActivate }
          sx={ { mt: 2 } }
        >
          { t("use_this_tab") }
        </Button> */ }
      </Paper>
    </Box>
  );
};
